<div class="generalPage" aria-label="help-jac content" role="main">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0':''">   
        <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-1rem" role="heading">{{jacc_heading}}</h1>
        <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="jacc_desc"></p>
      </div>
    </div>


